import {
  FacebookAuthProvider,
  GoogleAuthProvider,
  signInWithPopup,
} from "firebase/auth";
import { auth } from "./config";
import { loginWithSocial } from "../redux/zservices/BasicAPIFunctions";

const SOCIAL_FROM = {
  google: 2,
  facebook: 3,
  linkedin: Number(process.env.REACT_APP_LINKEDIN_SOCIAL_FROM || 4),
};

const LINKEDIN_CLIENT_ID = process.env.REACT_APP_LINKEDIN_CLIENT_ID;
const LINKEDIN_REDIRECT_URI =
  process.env.REACT_APP_LINKEDIN_REDIRECT_URI ||
  "https://apiadmin.urxprt.com/admin/v0_2/routes/linkedin";
const LINKEDIN_SCOPE = "openid profile email";
const LINKEDIN_STATE_KEY = "linkedin_oauth_state";
const LINKEDIN_SOCIAL_FROM_KEY = "linkedin_social_from";

const googleProvider = new GoogleAuthProvider();
const facebookProvider = new FacebookAuthProvider();

googleProvider.addScope("email");
googleProvider.addScope("profile");
facebookProvider.addScope("email");

const createOAuthState = () => {
  if (window.crypto?.randomUUID) {
    return window.crypto.randomUUID();
  }

  return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
};

const getNameParts = (displayName = "") => {
  const [firstName = "", ...lastNameParts] = displayName.trim().split(" ");

  return {
    first_name: firstName,
    last_name: lastNameParts.join(" "),
  };
};

const getCredentialToken = (credential) =>
  credential?.idToken || credential?.accessToken || "";

const buildSocialPayload = ({ result, credential, socialFrom }) => ({
  social_from: socialFrom,
  social_id: result.user.uid,
  social_token: getCredentialToken(credential),
});

const buildSignupDetails = ({ result, socialPayload }) => ({
  ...getNameParts(result.user.displayName),
  email_id: result.user.email || "",
  image: result.user.photoURL || null,
  ...socialPayload,
});

const signInWithProvider = async ({
  provider,
  socialFrom,
  getCredentialFromResult,
  providerName,
}) => {
  try {
    const result = await signInWithPopup(auth, provider);
    const credential = getCredentialFromResult(result);
    const socialPayload = buildSocialPayload({
      result,
      credential,
      socialFrom,
    });

    const loginRes = await loginWithSocial(socialPayload);
    console.log("Login linkedin: ", loginRes);

    return {
      loginRes,
      userdetailsforsignup: buildSignupDetails({
        result,
        socialPayload,
      }),
    };
  } catch (error) {
    console.error(`${providerName} Login Error:`, error);
    throw error;
  }
};

export const signInWithGoogle = () =>
  signInWithProvider({
    provider: googleProvider,
    socialFrom: SOCIAL_FROM.google,
    getCredentialFromResult: GoogleAuthProvider.credentialFromResult,
    providerName: "Google",
  });

export const signInWithFacebook = () =>
  signInWithProvider({
    provider: facebookProvider,
    socialFrom: SOCIAL_FROM.facebook,
    getCredentialFromResult: FacebookAuthProvider.credentialFromResult,
    providerName: "Facebook",
  });

export const signInWithLinkedIn = async () => {
  if (!LINKEDIN_CLIENT_ID || !LINKEDIN_REDIRECT_URI) {
    throw new Error("LinkedIn login is not configured");
  }

  const nonce = createOAuthState();
  const lan = localStorage.getItem("laung") || "en";
  const state = JSON.stringify({
    nonce,
    platform: "web",
    redirect_to: `${window.location.origin}/${lan}/linkedin/callback`,
  });

  sessionStorage.setItem(LINKEDIN_STATE_KEY, nonce);
  sessionStorage.setItem(
    LINKEDIN_SOCIAL_FROM_KEY,
    String(SOCIAL_FROM.linkedin)
  );

  const params = new URLSearchParams({
    response_type: "code",
    client_id: LINKEDIN_CLIENT_ID,
    redirect_uri: LINKEDIN_REDIRECT_URI,
    state,
    scope: LINKEDIN_SCOPE,
  });

  window.location.assign(
    `https://www.linkedin.com/oauth/v2/authorization?${params.toString()}`
  );

  return new Promise(() => {});
};
